/**
 * description push稿和头条详情页
 * created by lileilei
 * created on 2017-12-15
 */
'use strict';
angular.module('resourceCenterPushDetailModule', []).controller('resourceCenterPushDetailCtrl', [
    '$scope',
    '$rootScope',
    '$q',
    '$state',
    '$timeout',
    '$stateParams',
    '$filter',
    'trsHttpService',
    'modalDialog',
    'trsPrintService',
    'resourceCenterService',
    'resCtrModalService',
    'storageListenerService',
    'localStorageService',
    '$sce',
    function(
        $scope,
        $rootScope,
        $q,
        $state,
        $timeout,
        $stateParams,
        $filter,
        trsHttpService,
        modalDialog,
        trsPrintService,
        resourceCenterService,
        resCtrModalService,
        storageListenerService,
        localStorageService,
        $sce
    ) {
        initStatus();
        initData();

        /**
         * [initStatus description] 初始化状态
         * @return {[type]} [description]
         */
        function initStatus() {
            $scope.params = {
                typeid: 'zyzx',
                serviceid: 'appPush',
                modelid: 'detailData',
                indexName: $stateParams.indexname,
                isDetail: false,
                typeName: 'push',
                guid: $stateParams.guid,
            };
            if ($stateParams.isToutiao) {
                $scope.params.serviceid = 'toutiao';
                $scope.params.modelid = 'detailData';
                $scope.params.channelName = 'toutiao';
                delete $scope.params.isDetail;
                delete $scope.params.typeName;
            }
            $scope.status = {
                listOpen: 'processView', // 默认选中的属性信息
                attrDropdown: {
                    groupProcess: true, // 集团取签流程
                    groupEntityInfo: true, // 集团实体信息
                    authorInfo: true, // 作者信息
                    draftRelatedInfo: true, // 稿件关联信息
                    relevantDraft: true, // 相关稿件
                    groupReprint: true, // 集团转载
                    relatedHotwords: true, // 关联热点词
                    reprintMedia: true, // 转载媒体
                },
                hasPicture: false, // 地震稿件是否自带图片
                isTyphoon: false, // 是否为台风稿件
                isToutiao: $stateParams.isToutiao == true, // 是否为头条稿件
                isCollect: $state.params.iscollect, // 是否是从收藏稿件跳转过来的，如果是则没有顶部操作按钮
            };
            $scope.data = {
                keywordsArray: [], // 关键词数组
                tenantInfo: '', // 租户信息
                userName: '',
                groupProcess: {
                    // 集团取签流程
                    medias: [], // 媒体列表
                    operators: [
                        {
                            // 操作人
                            name: '取稿人',
                            value: 'takeDraft',
                        },
                        {
                            name: '签发人',
                            value: 'issue',
                        },
                        {
                            name: '见报人',
                            value: 'appearNews',
                        },
                        {
                            name: '撤稿人',
                            value: 'withdraw',
                        },
                    ],
                    process: [], // 取签流程
                    selectedMedia: '', // 选中的产品
                },
                authorInfo: {
                    // 作者信息
                    authorList: [
                        {
                            // 作者信息列表
                            COMPANY: '浙报集团',
                            DEPT: 'TRS',
                            USERNAME: '何志恺特殊小号部队1号',
                        },
                    ],
                },
                draftRelatedInfo: {
                    // 稿件关联信息
                    relatedInfo: [
                        {
                            // 关联信息分类
                            name: '关联领导人',
                            value: '',
                        },
                        {
                            name: '关联机构',
                            value: '1',
                        },
                        {
                            name: '关联地域',
                            value: '2',
                        },
                    ],
                    selectedRelatedInfo: '', // 选中的关联信息分类
                    relatedLeaders: [], // 关联领导人
                    relatedOrganizations: [], // 关联机构
                    relatedAreas: [], // 关联地域
                },
                relevantDraft: {
                    // 相关稿件
                    page: {
                        // 相关稿件分页
                        CURRPAGE: 1,
                        PAGESIZE: 10,
                    },
                    draftList: [], // 相关稿件列表
                },
                groupReprint: {
                    // 集团转载
                    reprintList: [],
                },
                relatedHotwords: {
                    // 关联热点词
                    hotwordsList: [],
                },
                picList: [], // 图集稿图片列表
            };
        }

        /**
         * [initData description] 初始化数据
         * @return {[type]} [description]
         */
        function initData() {
            requestData();
            getUserHeadPic();
            initQqjccInfos();
        }

        /**
         * [setPicList 设置图集稿图片列表]
         *
         * @return  {[type]}  [return description]
         */
        function setPicList() {
            if ($scope.detailInfos.DOC_TYPE === '2') {
                var str = $scope.detailInfos.IMGURLS;
                $scope.data.picList = JSON.parse(str);
                let setList = [];
                $scope.data.picList.forEach((item, index) => {
                    let check = false;
                    if (index === 0) {
                        check = true;
                    }
                    setList.push({
                        PERPICURL: item.imgurl,
                        active: check,
                        APPDESC: item.ts,
                    });
                });
                $scope.data.picList = setList;
            }
        }

        /**
         * [requestData description] 请求数据
         * @return {[type]} [description]
         */
        function requestData() {
            $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getBigDataRootUrl(), $scope.params, 'post').then(function(data) {
                if (data && data.content) {
                    $scope.detailIndexname = data.summary_info.indexName;
                    $scope.detailInfos = data.content[0];
                    setPicList();
                    var date = new Date(Date.parse($scope.detailInfos.DOCPUBTIME));
                    $scope.detailInfos.DOCPUBTIME = $filter('date')(date, 'yyyy-MM-dd HH:mm:ss').toString();
                    $scope.status.hasPicture = !(data.content[0].CONTENT.indexOf('<img src=') > -1);
                    $scope.keywords = data.content[0].ZB_KEYWORDS5;
                    $scope.data.keywordsArray = data.content[0].ZB_KEYWORDS5 === '' ? [] : data.content[0].ZB_KEYWORDS5.split(';');
                    if (!!data.content[0].ENTITY_ORG) {
                        var org = data.content[0].ENTITY_ORG.split(';');
                        for (var i = 0; i < org.length; i++) {
                            $scope.data.draftRelatedInfo.relatedOrganizations.push({
                                name: org[i],
                                random: Math.ceil(Math.random() * 5),
                            });
                        }
                    }
                    if (!!data.content[0].ENTITY_PLACE) {
                        var entityPlace = data.content[0].ENTITY_PLACE.split(';');
                        for (var j = 0; j < entityPlace.length; j++) {
                            $scope.data.draftRelatedInfo.relatedAreas.push({
                                name: entityPlace[j],
                                random: Math.ceil(Math.random() * 5),
                            });
                        }
                    }
                    findReprintCounts();
                    getRelatedHotwords();
                    getTenantId().then(function() {
                        getRelatedLeaders();
                        getRelevantDraft();
                        getGroupReprint();
                    });
                    if ($scope.channelName == 'wb') {
                        getWeiboImg();
                    }
                }
            });
            initQqjccInfos();
            showSourceSite();
            headPortrait();
        }

        /**
         * [getUserHeadPic description] 获取用户头像
         * @return {[type]} [description]
         */
        function getUserHeadPic() {
            var params = {
                serviceid: 'mlf_extuser',
                methodname: 'getUserHeadPic',
            };
            trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(function(data) {
                $scope.headPic = data.USERHEAD[0].PERPICURL == '' ? './images/user_icon.jpg' : data.USERHEAD[0].PERPICURL;
            });
        }

        /**
         * [initQqjccInfos description] 初始化取签见撤重信息
         * @return {[type]} [description]
         */
        function initQqjccInfos() {
            getQqjccChannel();
            getQqjccInfo();
        }

        /**
         * [getQqjccChannel description] 获取取签见撤重媒体
         * @return {[type]} [description]
         */
        function getQqjccChannel() {
            var params = {
                serviceid: 'mlf_bigdataexchange',
                methodname: 'queryOperMediasList',
                guid: $stateParams.guid,
            };
            trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(function(data) {
                $scope.data.groupProcess.medias = [
                    {
                        MEDIANAME: '全部',
                        MEDIATYPE: '',
                        MEDIAID: '',
                    },
                ].concat(data);
                $scope.data.groupProcess.selectedMedia = $scope.data.groupProcess.medias[0];
            });
        }

        /**
         * [getQqjccInfo description] 获取取签见撤重信息
         * @return {[type]} [description]
         */
        function getQqjccInfo() {
            var params = {
                serviceid: 'mlf_bigdataexchange',
                methodname: 'queryOperFlagList',
                guid: $stateParams.guid,
                mediaid: $scope.data.groupProcess.selectedMedia.MEDIAID,
                mediatype: $scope.data.groupProcess.selectedMedia.MEDIATYPE,
            };
            trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(function(data) {
                $scope.data.groupProcess.process = data.OPERS;
                if ($scope.data.groupProcess.process.length > 1) {
                    $('.resource_detail .groupProcess_process').css('height', ($scope.data.groupProcess.process.length - 1) * 120 + 'px');
                } else {
                    $('.resource_detail .groupProcess_process').css('height', '0px');
                }
            });
        }

        /**
         * [selectQqjccChannel description] 选择取签见撤重媒体
         * @param  {[type]} media [description] 当前媒体
         * @return {[type]}       [description]
         */
        $scope.selectQqjccChannel = function(media) {
            $scope.data.groupProcess.selectedMedia = media;
            getQqjccInfo();
        };

        /**
         * [showSourceSite description] 显示来源名称
         * @return {[type]} [description]
         */
        function showSourceSite() {
            var firstFiledOfIndexname = '';
            if (angular.isDefined($stateParams.indexname)) {
                firstFiledOfIndexname = $stateParams.indexname.split('_')[0];
            }
            if ($scope.channelName == 'wz' || firstFiledOfIndexname == 'website') {
                $scope.status.showSourceSite = 'wz';
            } else if ($scope.channelName == 'app' || firstFiledOfIndexname == 'app') {
                $scope.status.showSourceSite = 'app';
            } else if ($stateParams.channel == 'unknownchannel') {
                $scope.status.showSourceSite = 'unknownChannel';
            } else {
                $scope.status.showSourceSite = 'others';
            }
            if (
                $scope.channelName == 'wz' ||
                $scope.channelName == 'app' ||
                $scope.channelName == 'unknownchannel' ||
                firstFiledOfIndexname == 'website' ||
                firstFiledOfIndexname == 'app'
            ) {
                $scope.status.isReprintShow = true;
            } else {
                $scope.status.isReprintShow = false;
            }
        }

        /**
         * [getTenantId description] 获取租户id
         * @return {[type]} [description]
         */
        function getTenantId() {
            var defer = $q.defer();
            var params = {
                serviceid: 'mlf_tenant',
                methodName: 'findTenantById',
            };
            trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(function(data) {
                $scope.data.tenantInfo = data;
                defer.resolve();
            });
            return defer.promise;
        }

        /**
         * [getRelatedLeaders description] 获取关联领导人
         * @return {[type]}    [description]
         */
        function getRelatedLeaders() {
            var params = {
                serviceid: 'relevant',
                modelid: 'getRelevantLeader',
                typeid: 'zyzx',
                tarentId: $scope.data.tenantInfo.TENANTID,
                names: $scope.detailInfos.ENTITY_NAME,
            };
            trsHttpService.httpServer(trsHttpService.getBigDataRootUrl(), params, 'post').then(function(data) {
                $scope.data.draftRelatedInfo.relatedLeaders = data;
            });
        }
        $scope.showIconColor = function() {
            var random = Math.ceil(Math.random() * 5);
            return 'color' + random;
        };

        /**
         * [getRelevantDraft description] 获取关联稿件
         * @return {[type]}    [description]
         */
        function getRelevantDraft() {
            var params = {
                serviceid: 'relevant',
                modelid: 'getRelevantManuscript',
                typeid: 'zyzx',
                tarentId: $scope.data.tenantInfo.TENANTID,
                guid: $stateParams.guid,
                pageSize: $scope.data.relevantDraft.page.PAGESIZE,
                pageNum: $scope.data.relevantDraft.page.CURRPAGE,
                keywords: $scope.keywords,
            };
            trsHttpService.httpServer(trsHttpService.getBigDataRootUrl(), params, 'post').then(function(data) {
                $scope.data.relevantDraft.page = {
                    CURRPAGE: data.pageNum,
                    ITEMCOUNT: data.totalNum,
                    PAGECOUNT: data.totalPageNum,
                    PAGESIZE: data.pageSize,
                };
                $scope.data.relevantDraft.draftList = data.content;
                // storageListenerService.appendPageTurningStorage(data.content, "guid,dataBaseName,mediaChar", "resourceDetail", "ZB_GUID,indexname,channel");
            });
        }

        /**
         * [relevantDraftPageChanged description] 关联稿件分页
         * @return {[type]} [description]
         */
        $scope.relevantDraftPageChanged = function() {
            getRelevantDraft();
        };

        /**
         * [getGroupReprint description] 获取集团转载
         * @return {[type]} [description]
         */
        function getGroupReprint() {
            var params = {
                serviceid: 'jtcpg',
                modelid: 'Analysis',
                typeid: 'zyzx',
                md5: $scope.detailInfos.MD5TAG,
                // userId: "",
                // rentId: $scope.data.tenantInfo.TENANTID
            };
            trsHttpService.httpServer(trsHttpService.getBigDataRootUrl(), params, 'post').then(function(data) {
                $scope.data.groupReprint.reprintList = data.content;
            });
        }

        /**
         * [getRelatedHotwords description] 获取关联热点词
         * @return {[type]} [description]
         */
        function getRelatedHotwords() {
            var params = {
                serviceid: 'relevant',
                modelid: 'getRelevantKeywords',
                typeid: 'zyzx',
                keyword: $scope.keywords,
            };
            trsHttpService.httpServer(trsHttpService.getBigDataRootUrl(), params, 'post').then(function(data) {
                if (angular.isObject(data)) {
                    var tempArray;
                    for (var i in data) {
                        tempArray = {};
                        tempArray.mainCloud = {
                            name: i,
                        };
                        tempArray.subCloud = [];
                        for (var j in data[i]) {
                            for (var k in data[i][j]) {
                                tempArray.subCloud.push({ name: k, value: data[i][j][k] });
                            }
                        }
                        $scope.data.relatedHotwords.hotwordsList.push(tempArray);
                    }
                }
            });
        }

        /**
         * [findReprintCounts description] 获取转载量
         * @return {[type]} [description]
         */
        function findReprintCounts() {
            var params = {
                typeid: 'zyzx',
                serviceid: 'jtcpg',
                modelId: 'findReprintCounts',
                tags: $scope.detailInfos.MD5TAG,
            };
            trsHttpService.httpServer(trsHttpService.getBigDataRootUrl(), params, 'post').then(function(data) {
                $scope.data.reprintCounts = !!data.content[0] ? data.content[0][$scope.detailInfos.MD5TAG] : '0';                       
            });
        }

        /**
         * [getWeiboImg description] 获取微博图片
         * @return {[type]} [description]
         */
        function getWeiboImg() {
            var params = {
                typeid: 'zyzx',
                modelid: 'getImgList',
                serviceid: 'wb',
                channelName: 'wb',
                guids: $stateParams.guid,
            };
            trsHttpService.httpServer(trsHttpService.getBigDataRootUrl(), params, 'post').then(function(data) {
                if (angular.isArray(data.content) && data.content.length > 0) {
                    $scope.detailInfos.imgurl = [];
                    for (var i = 0; i < data.content[0][$stateParams.guid].IMAGEURLS.length; i++) {
                        $scope.detailInfos.imgurl[i] = data.content[0][$stateParams.guid].IMAGEURLS[i].urlM;
                    }
                }
            });
        }

        /**
         * [jumpToDetail description] 跳转到关联稿件
         * @param  {[type]} draftList [description]
         * @return {[type]}           [description]
         */
        $scope.jumpToDetail = function(draftList) {
            storageListenerService.relatedPageTurningStorage(
                $scope.data.relevantDraft.draftList,
                'guid,dataBaseName,mediaChar',
                'relatedDetail',
                'ZB_GUID,indexname,channel'
            );
            if (draftList.mediaChar == 'xhsg') {
                window.open($state.href('front.resourcectrl.xinhua', { guid: draftList.guid, indexname: draftList.dataBaseName, relateddetail: 1 }));
            } else {
                window.open($state.href('resourcedetail', { guid: draftList.guid, indexname: draftList.dataBaseName, relateddetail: 1 }));
            }
        };

        /**
         * [pageTurning description] 翻页 上一篇/下一篇
         * @param {int} direction [description]
         * @return {[type]} [description]
         */
        $scope.pageTurning = function(direction) {
            var id;
            var temp;
            if ($stateParams.relateddetail == 1 || $stateParams.relateddetail == 2) {
                temp = localStorageService.get('relatedDetail');
            } else {
                temp = localStorageService.get('resourceDetail');
            }
            if (typeof temp === 'string') {
                temp = JSON.parse(temp);
            }
            if ($stateParams.isToutiao) {
                id = 'ZB_GUID';
            } else {
                id = 'GUID';
            }
            var toPageData;
            for (var i = 0; i < temp.length; i++) {
                if (temp[i][id] === $stateParams.guid) {
                    toPageData = temp[i + direction];
                    break;
                }
            }
            if (!toPageData) {
                var directionTxt = direction === 1 ? '下' : '上';
                modalDialog.alertType('没有' + directionTxt + '一篇了！', '', 'warning', false);
                return;
            }
            if ($stateParams.relateddetail == 1) {
                // 相关稿件
                if (toPageData.channel == 'xhsg') {
                    $state.go('front.resourcectrl.xinhua', { guid: toPageData.ZB_GUID, indexname: toPageData.indexname, relateddetail: 1 });
                } else {
                    $state.go('resourcedetail', { guid: toPageData.ZB_GUID, indexname: toPageData.indexname, relateddetail: 1 });
                }
            } else if ($stateParams.relateddetail == 2) {
                // 高级检索结果
                if (toPageData.channel === 'szb') {
                    $state.go('resourcepushdetail', {
                        guid: toPageData.ZB_GUID,
                        indexname: toPageData.indexname,
                        channel: toPageData.channel,
                        relateddetail: 2,
                    }, {
                        reload: true
                    });
                } else {
                    $state.go('resourcexhsgbigdatadetail', { guid: toPageData.ZB_GUID, indexname: toPageData.indexname, relateddetail: 2 }, {
                        reload: true
                    });
                }
            } else {
                $state.go($state.current.name, {
                    guid: toPageData[id],
                }, {
                    reload: true
                });
            }
        };

        /**
         * [contentResize description] 设置左右侧高度一样
         * @return {[type]} [description]
         */
        $scope.contentResize = function() {
            $timeout(function() {
                var $father = $('.resource_detail');
                var $left = $father.find('.resource_detail_article');
                var $right = $father.find('.resource_detail_relatedInfo');
                var leftHeight = $left.height();
                $right.height(leftHeight);
                $left.resize(function(event) {
                    var leftHeight = $left.height();
                    $right.height(leftHeight);
                });
            });
        };

        /* 稿件操作开始*/
        /**
         * [collection description] 收藏
         * @return {[type]} [description]
         */
        $scope.collect = function() {
            var params = {
                serviceid: 'mlf_bigdataexchange',
                methodname: 'collect',
                guid: $stateParams.guid,
                channelName: $stateParams.isToutiao ? 'toutiao' : 'appPush',
                indexname: $stateParams.indexname,
            };
            $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'post').then(function(data) {
                modalDialog.alertType('收藏成功!', '', 'success', false, '');
            });
        };

        /**
         * [creationAxis description] 个人素材
         * @return {[type]} [description]
         */
        $scope.creationAxis = function() {
            var params = {
                serviceid: 'mlf_bigdataexchange',
                methodname: 'batchPersonalMaterial',
                PersonalMaterialId: '0',
                guid: $stateParams.guid,
                channelName: $stateParams.isToutiao ? 'toutiao' : 'appPush',
                indexname: $stateParams.indexname,
            };
            $scope.loadingPromise = resourceCenterService.setBigDataCreation(params).then(function(data) {
                modalDialog.alertType('添加成功', '', 'success', false);
            });
        };

        /**
         * [takeDraft description] 取稿
         * @return {[type]} [description]
         */
        $scope.openTakeDraftModal = function() {
            var params = {
                serviceid: 'mlf_bigdataexchange',
                methodname: 'fetch',
                guid: $stateParams.guid,
                channelName: $stateParams.isToutiao ? 'toutiao' : 'appPush',
                indexname: $stateParams.indexname,
            };
            var modalInstance = resCtrModalService.fullTakeDraft(params, true, [$scope.detailInfos]);
            modalInstance.result.then(
                function(data) {
                    takeDraftDownloadImgs(data).then(function() {
                        storageListenerService.addListenerToResource('takeDraft');
                        initData();
                    });
                },
                function() {
                    storageListenerService.addListenerToResource('takeDraft');
                    initData();
                }
            );
        };

        /**
         * [takeDraftDownloadImgs description]  图片正在下载中情况，跳转至下载弹窗
         * @param  {[type]} data [description]
         * @return {[type]}      [description]
         */
        function takeDraftDownloadImgs(data) {
            var deferred = $q.defer();
            var needDownloadImg = false;
            for (var i = 0; i < data.REPORTS.length; i++) {
                if (data.REPORTS[i].PICERROR == 1) {
                    needDownloadImg = true;
                    break;
                }
            }
            if (needDownloadImg) {
                resCtrModalService.takeDraftDownloadImgs(data, function(res) {
                    deferred.resolve();
                });
            } else {
                deferred.resolve();
            }
            return deferred.promise;
        }

        /**
         * [print description] 打印
         * @return {[type]} [description]
         */
        $scope.printBtn = function() {
            $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getBigDataRootUrl(), $scope.params, 'post').then(function(data) {
                trsPrintService.trsPrintRobot(data);
            });
        };

        /**
         * [originalText description] 阅读原文
         * @return {[type]} [description]
         */
        $scope.originalText = function() {
            window.open($scope.detailInfos.PUBURL);
        };

        /**
         * [conversion description] 处理video的url格式
         *
         * @return  {[type]}  [return description]
         */
        $scope.conversion = function() {
            var videoRel = JSON.parse($scope.detailInfos.IR_VIEDO_URL);
            return $sce.trustAsResourceUrl(videoRel[0].videoUrl);
        };

        /* 稿件操作结束*/

        // 获取头像
        function headPortrait() {
            // detail
            var params = {
                serviceid: 'mlf_extuser',
                methodname: 'getUserHeadPic',
            };
            trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(function(data) {
                $scope.headPic = data.USERHEAD[0].PERPICURL == '' ? './images/user_icon.jpg' : data.USERHEAD[0].PERPICURL;
            });
        }
        $rootScope.$on('updateHeadPortrait', function(event, data) {
            headPortrait();
        });
    },
]);
